import { SvgIcon, SvgIconProps } from '@mui/material';

export const ShippingStandardIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox='0 0 49 41' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M20.4978 32.8297H24.8789C26.5816 32.8297 27.9619 31.4494 27.9619 29.7467V5.08297C27.9619 3.38029 26.5816 2 24.8789 2H5.08297C3.38029 2 2 3.38029 2 5.08297V29.7467C2 31.4494 3.38029 32.8297 5.08297 32.8297H8.16594'
          stroke='currentColor'
          strokeWidth='3.6975'
        />
        <path
          d='M29.3548 8.17188H37.6871C42.7951 8.17188 46.936 12.3128 46.936 17.4208V29.7527C46.936 31.4553 45.5557 32.8356 43.853 32.8356H42.0681M23.5703 32.8356H29.7363'
          stroke='currentColor'
          strokeWidth='3.6975'
          strokeLinecap='round'
        />
        <circle cx='14.33' cy='32.8339' r='6.16594' stroke='currentColor' strokeWidth='3.6975' />
        <circle cx='35.9081' cy='32.8339' r='6.16594' stroke='currentColor' strokeWidth='3.6975' />
      </svg>
    </SvgIcon>
  );
};
